import { FC } from "react";
import { useHistory } from "react-router-dom";

import { RouteKey, RoutePath } from "../configs/routes";
import { Layout } from "../components/Layout";
import { Amount } from "../utils/context";
import { AmountsGrid } from "../components/AmountsGrid";
import { useStorage } from "../utils/useStorage";

export const AddDrink: FC = () => {
  const history = useHistory();
  const { addDrink } = useStorage();

  const handleAdd = (amount: Amount) => {
    addDrink && addDrink(amount);
    history.push(RoutePath[RouteKey.INDEX]);
  }

  return (
    <Layout route={RouteKey.ADD_DRINK}>
      <AmountsGrid onAdd={handleAdd} />
    </Layout>
  )
}